import { Button, Drawer, Modal, Space } from "antd";

const WrappingModal = ({
  title,
  isModalOpen,
  handleCancel,
  form,
  loading,
  children,
}) => {
  return (
    <>
      {/* <Modal
      title={title}
      width={"100%"}
      open={isModalOpen}
      onCancel={handleCancel}
      cancelText="خروج"
      okText={title}
      onOk={() => form.submit()}
      centered
      confirmLoading={loading}
      className="w-full h-full max-w-none p-0 m-0"
      style={{ height: "100vh", overflow: "auto" }}
    > */}
      <Drawer
        closable
        destroyOnClose
        title={title}
        placement="right"
        open={isModalOpen}
        // loading={true}
        onClose={handleCancel}
        size="large"
        width="100vw"
        extra={
          <Space>
            <Button onClick={handleCancel}>خروج</Button>
            <Button
              loading={loading}
              type="primary"
              onClick={() => form.submit()}
            >
              {title}
            </Button>
          </Space>
        }
      >
        <div className="px-5">{children}</div>
      </Drawer>

      {/* </Modal> */}
    </>
  );
};

export default WrappingModal;
